import { z } from 'zod';

export const FiltersResponseSchema = z.object({
  categories: z.array(
    z.object({
      name: z.string(),
      label: z.string(),
      type: z.string().optional(),
    }),
  ),
  channels: z.array(
    z.object({
      name: z.string(),
      label: z.string(),
      type: z.string().optional(),
    }),
  ),
  types: z.array(
    z.object({
      name: z.string(),
      label: z.string(),
      type: z.string().optional(),
    }),
  ),
});
